import { render, staticRenderFns } from "./InstrumentMetadata.vue?vue&type=template&id=3a9f867a&scoped=true"
import script from "./InstrumentMetadata.vue?vue&type=script&lang=ts"
export * from "./InstrumentMetadata.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9f867a",
  null
  
)

export default component.exports